// extracted by mini-css-extract-plugin
export default {"promotions-holder":"InvestmentPromotions_promotions-holder__Fr0k0","image-banner":"InvestmentPromotions_image-banner__sUo1n"};